module.exports = __webpack_public_path__ + "media/packs/images/flags/SO-fc4f2d9668ce73450c06ed8dd239fdf5.png";